import React from "react";
import { Table, Header, Icon, Segment } from "semantic-ui-react";
import "./index.css";

interface SupplyUnit {
  upc: string;
  supply_title: string;
  part_number: string;
  inventory_id: number;
  inventory_title: string | null;
}

interface HierarchicalSupplyUnitsListProps {
  supplyUnits: SupplyUnit[];
  openDeleteInventoryModal?: (inventoryId: number, units: SupplyUnit[]) => void;
  interactable?: boolean;
}

function HierarchicalSupplyUnitsList({
  supplyUnits,
  openDeleteInventoryModal,
  interactable = true,
}: HierarchicalSupplyUnitsListProps) {
  const groupedUnits = supplyUnits.reduce<
    Record<string, Record<string, SupplyUnit[]>>
  >((acc, unit) => {
    if (!acc[unit.part_number]) acc[unit.part_number] = {};
    if (!acc[unit.part_number][unit.inventory_id])
      acc[unit.part_number][unit.inventory_id] = [];
    acc[unit.part_number][unit.inventory_id].push(unit);
    return acc;
  }, {});

  return (
    <Segment>
      <Table basic="very">
        <Table.Header>
          <Table.Row className="large-row">
            <Table.HeaderCell>Part Number</Table.HeaderCell>
            <Table.HeaderCell>Inventory ID</Table.HeaderCell>
            <Table.HeaderCell>Title</Table.HeaderCell>
            <Table.HeaderCell>UPC</Table.HeaderCell>
            <Table.HeaderCell />
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Object.entries(groupedUnits).map(([partNumber, inventories]) => (
            <React.Fragment key={partNumber}>
              <Table.Row className="large-row">
                <Table.Cell colSpan={5}>
                  <Header as="h4">{partNumber}</Header>
                </Table.Cell>
              </Table.Row>
              {Object.entries(inventories).map(([inventoryId, units]) => (
                <React.Fragment key={`${partNumber}-${inventoryId}`}>
                  <Table.Row className="large-row">
                    <Table.Cell />
                    <Table.Cell>{inventoryId}</Table.Cell>
                    <Table.Cell>
                      {units[0].inventory_title || "No title"}
                    </Table.Cell>
                    <Table.Cell />
                    <Table.Cell>
                      {interactable && openDeleteInventoryModal && (
                        <Icon
                          name="trash"
                          title="Remove inventory from product"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            openDeleteInventoryModal(Number(inventoryId), units)
                          }
                        />
                      )}
                    </Table.Cell>
                  </Table.Row>
                  {units.map((unit) => (
                    <Table.Row key={unit.upc} className="large-row">
                      <Table.Cell />
                      <Table.Cell />
                      <Table.Cell>
                        <span style={{ marginLeft: "2em", color: "rgba(0,0,0,0.6)" }}>
                          {unit.supply_title}
                        </span>
                      </Table.Cell>
                      <Table.Cell>
                        <span style={{ color: "rgba(0,0,0,0.6)" }}>{unit.upc}</span>
                      </Table.Cell>
                      <Table.Cell />
                    </Table.Row>
                  ))}
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </Table.Body>
      </Table>
    </Segment>
  );
}

export { HierarchicalSupplyUnitsList };
export type { SupplyUnit };
